import { Entity, Key } from '@briebug/ngrx-auto-entity';

@Entity({
  modelName: 'WorkOrderDraft',
  uriName: 'work-order-drafts',
})
export class WorkOrderDraft {
  @Key id!: number;
}
